import React from 'react';
import { connect } from "react-redux";
import { Container, Row, Col, Table, Button } from 'react-bootstrap'
import PageBanner from '../common/page/PageBanner'
import Alert from '../common/modal/Alert';
import Paginator from '../common/page/Paginator'
import { getPaginatorHelper } from '../common/page/PaginatorHelper'
import Loading from '../common/modal/Loading';
import configData from "../../config/config.json";
import axios from "axios";

import { setSelectedTenantAdminType, EmailListTenantAdminKey  } from "../../redux/actions/tenantAdminActions";
import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants";

const componentName = EmailListTenantAdminKey;
export const EmailListTenantAdminComponentName = "EmailListTenantAdminComponentName";

const mapStateToProps = state => {

	return {
		sideNavigationOpen: state.sideNavigationReducer,
		paginationPage: state.emailAddressesPaginationTenantAdminReducer,
		alertListFilters: state.alertListFiltersReducer, //chris
		role: state.currentUserReducer.role 
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		alertListEmailAddressFilter: (emailAddressId, emailAddressName) => dispatch({ type: 'SET_ALERT_LIST_EMAIL_ADDRESS_FILTER', emailAddressFilter: {emailAddressId, emailAddressName} }),
		setSelectedTenantAdminType: () => dispatch(setSelectedTenantAdminType(componentName))
	}
}

class EmailList extends React.Component {

	state = {
		filteredList: [],
		filterText: '',
		selectedId: 0,
		selectedEmailname: '',
		status: '',
		showAlert: false,
		alertMessage: "",
		alertType: ALERT_TYPES.OK,
		filteringKey: 0 /*Is incremeted to re-render/mount the Paginator component */
	}

	showLoading = () => {
		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleTextFilter = (filterText) => {
		this.setState({ filterText: filterText, filteringKey: this.state.filteringKey + 1 },  function() { this.handleFilter() } )
	}	

	handleTextFilterReset = () => {
		this.setState({ filterText: '', filteringKey: this.state.filteringKey + 1 }, function () { this.handleFilter() })
	}

	handleFilter = () => {
		if (this.showLoading() !== true) {
			return;
		}

		let filters = { filterText: this.state.filterText };
		axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/emails", filters, { withCredentials: true })
		.then((response) => {
			this.setState({filteredList: response.data.content.emailAddresses, status: '' })
		}, (error) => {
			this.setState({ status: '' }, this.showWarning(error.message));
		});
	}

	showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }

	showWarning = (alertMessage) => {
		this.setState({
		  alertType: ALERT_TYPES.WARNING,
		  showAlert: true,
		  alertMessage
		})
	}
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: "",
			alertType: ALERT_TYPES.OK
		}, this.props.history.push('/tenantAdmin/users'))
	}

	handleRedirectToAlerts = (event) => {
		event.preventDefault();
		let selectedEmailId = event.target.closest("tr").id;
		let selectedEmailName = event.target.closest("tr").getAttribute("name");
	
		this.setState({ selectedEmailId, selectedEmailName });
	
		this.props.history.push('/tenantAdmin/alerts');
	
		this.props.alertListEmailAddressFilter(selectedEmailId, selectedEmailName);
	  }

	componentDidMount() {
		this.props.setSelectedTenantAdminType();
		this.handleFilter();
	}

	render() {

		let formTemplateMarginLeft = 60
		if (this.props.sideNavigationOpen) {
		  formTemplateMarginLeft = 270
		}

		const textFilterProps = {
			textFilter: this.handleTextFilter,
			textFilterReset: this.handleTextFilterReset,
			filterText: this.state.filterText
		}

		const numberOfVisibleRecords = 10;
		let numberOfPages = Math.ceil ( this.state.filteredList.length / numberOfVisibleRecords );
		let paginationHelper = getPaginatorHelper(this.props.paginationPage, this.state.filteredList, numberOfVisibleRecords);

		return (
		
			<div style={{ marginTop: 4, marginLeft: formTemplateMarginLeft, marginRight: 20, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)"  }}>
				{ 	
					(this.props.role === 'FOREVER' || this.props.role === 'TRIMIN' || this.props.role === 'TENANT') &&
					<PageBanner pageHeading='Emails' textFilterProps={textFilterProps }/>
				}
				<Container fluid="true">
					<Row>
						<Col style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0, marginTop: 20, marginLeft: 20,  marginRight: 20, border: '3px solid darkGray', borderRadius: '5px' }}>
							<Table striped hover size="sm" >
								<thead>
									<tr>
										<th style={{width: '30%'}} scope="col">Email</th>
										<th style={{width: '10%'}} scope="col">Migrated</th>
										<th style={{width: '40%'}} scope="col"></th>
									</tr>
								</thead>

								<tbody>
									{
										paginationHelper.currentPageRecordList.map((emailAddressResult) => {
											let inactiveBadge = '';
											if ( emailAddressResult.status === 'I') {
												inactiveBadge = "inactive";
											} 
											return (
												<tr style={{ cursor: "pointer" }} id={emailAddressResult.id} name={emailAddressResult.emailAddress}  onClick={this.handleRowClick}>
													<td>{emailAddressResult.emailAddress}<span className='badge badge-light'>{inactiveBadge}</span></td>
												
													<td>{emailAddressResult.verified ? "Yes" : "No"}</td>
													<td style={{ float: 'right' }}>
														<Button variant="primary" size='sm' onClick={this.handleRedirectToAlerts}>Alerts ({emailAddressResult.alertCount})</Button>&nbsp;	
													</td>
												</tr>
											)
										})
									}
								</tbody>
							</Table>
						</Col>
					</Row>
					<Row>&nbsp;</Row>
					<Row>
						<Col style={{marginLeft: 4}}>Displaying Results: {paginationHelper.currentPageStartingRecordNumber}-{paginationHelper.currentPageEndingRecordNumber} of {this.state.filteredList.length}</Col>
						<Col><Paginator style={{justifyContent: 'center'}} componentName={EmailListTenantAdminComponentName} key={this.state.filteringKey} numberOfVisibleRecords={numberOfVisibleRecords} numberOfPages={numberOfPages} ></Paginator></Col>
					</Row>
				</Container>
				
				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
			</div>

		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailList);